import { useTranslation } from 'react-i18next'
import { ContentSection } from '../components/content-section'
import { LlmSettingsForm } from './llm-settings-form'

export function SettingsLlm() {
  const { t } = useTranslation('common')

  return (
    <ContentSection
      title={t('settingsLlm.title')}
      desc={t('settingsLlm.description')}
    >
      <LlmSettingsForm />
    </ContentSection>
  )
}
